const firebaseConfig = {
  apiKey: "AIzaSyB8dBWPjmJFdWCIQXoMdp5xQ-oY2Fbz6g4",
  authDomain: "master-study-dc2da.firebaseapp.com",
  projectId: "master-study-dc2da",
  storageBucket: "master-study-dc2da.appspot.com",
  messagingSenderId: "721329580648",
  appId: "1:721329580648:web:d9d9ae3cb34e765d72e9dd",
};
export default firebaseConfig;
